import { useEffect, useState } from 'react';
import { useAuth } from 'src/components/context/AuthContextProvider';
import { canSeeOEReportLink } from './oeReportAccess';

/**
 * Whether the current user may see the Interactive OE Report nav link.
 *
 * Starts `false` and flips to `true` once the SSM allowlist resolves, so the link
 * appears a moment after first paint for permitted users. That ordering is
 * deliberate: the check is asynchronous (an SSM read) while nav renders
 * synchronously, and starting hidden means a slow or failed lookup never briefly
 * exposes the link.
 */
export const useOEReportLinkVisible = (): boolean => {
  const { Alias } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    canSeeOEReportLink(Alias).then((allowed) => {
      if (!cancelled) setVisible(allowed);
    });
    return () => {
      cancelled = true;
    };
  }, [Alias]);

  return visible;
};
